<template>
  <div class="kk_designer-settings_wrapper">
    <more-commands v-if="activeTab === 4" />
  </div>
</template>
<script>
import MoreCommands from "../process-design/access-toolbar/MoreCommands.vue";
export default {
  components: {
    MoreCommands,
  },
  computed: {
    activeTab() {
      return this.$store.state.preferences.settingsActiveTab;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";
.kk_designer-settings {
  &_wrapper {
    width: 100%;
    padding: 1.1rem 1.1rem 1.1rem 1.6rem;
    position: relative;
    overflow: auto;
    height: calc(100vh - 4rem);

    /* Hide the scrollbar for Internet Explorer, Edge and Firefox */
    -ms-overflow-style: none; /* Internet Explorer and Edge */
    scrollbar-width: none; /* Firefox */

    /* Hide the scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
